import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FaRegTimesCircle } from "react-icons/fa";
import styles from "./AddNotes.module.scss";
import { toast } from "react-toastify";

const AnomaliesAddNotes = ({
  onClose,
  onSave,
}: {
  onClose: CallableFunction;
  onSave: CallableFunction;
}) => {
  const [note, setNote] = useState("");

  const handleSave = () => {
    if (note?.length <= 10) {
      toast.info("Note should be at least 10 characters.");
    } else {
      onSave(note);
    }
  };

  const handleChange = (e: any) => {
    setNote(e.target.value);
  };

  return (
    <Modal show={true} className={styles.addNoteModal}>
      <Modal.Header>
        <Modal.Title>
          <span className="fs-24 fw-700 text-grey-900">Add note</span>
        </Modal.Title>
        <FaRegTimesCircle
          size={28}
          className="cursor-pointer"
          onClick={() => {
            onClose();
          }}
        />
      </Modal.Header>
      <Modal.Body>
        <div className="p-4">
          <div className="form-group">
            <textarea
              className="form-control"
              rows={8}
              onChange={handleChange}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-block">
        <div className="row py-2">
          <div className="col-6">
            <button
              className="btn btn-outline-secondary w-100 d-block py-2 btn-lg"
              onClick={() => {
                onClose();
              }}
            >
              Cancel
            </button>
          </div>
          <div className="col-6">
            <button
              className="btn btn-success w-100 d-block py-2 btn-lg"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AnomaliesAddNotes;
